import { useSessionStore } from '../../store/sessionStore';
import type { HomeAction } from './PlayView';

/**
 * The connecting line and the last join error. "Connecting…" shows here only when no button of
 * this view is labelled with it: a resumed session, or a join from the open matches list.
 */
export function HomeStatus({ pending }: { pending: HomeAction | null }) {
  const busy = useSessionStore((s) => s.status === 'connecting');
  const error = useSessionStore((s) => s.error);
  return (
    <div className="home-status" role="status">
      {busy && (pending === null || pending === 'browser') && <p className="muted">Connecting…</p>}
      {error && <p className="error">{error}</p>}
    </div>
  );
}
